import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { PopoverCardEl } from "common/components/popover-card";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu/panel";
import { VIEWS } from "./types";
export function template() {
  var _this$state$positionP;
  const {
    dropMenuOpen,
    view
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".actions-popover-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: this.attr("open") && dropMenuOpen,
    "prevent-close-selectors": ["mp-create-entity-modal", ...this.attr("prevent-close-selectors")],
    "experimental-positioning": true
  }, on: {
    change: this.helpers.handleDropMenuChange,
    click: (ev) => ev.stopPropagation()
  }, props: {
    positionParent: (_this$state$positionP = this.state.positionParent) !== null && _this$state$positionP !== void 0 ? _this$state$positionP : this
  }, "data-sentry-element": "DropMenuEl", "data-sentry-source-file": "template.tsx" }, view === VIEWS.BREAKDOWN ? /* @__PURE__ */ jsx(PropertiesMenuEl, { disabledItems: this.helpers.breakdownDisabledItemsMap(), eventNames: [this.attr("event")], open: this.attr("open"), projectId: this.helpers.getProjectId(), workspaceId: this.attr("workspace-id"), onSelect: this.helpers.handleBreakdownMenuSelect }) : /* @__PURE__ */ jsx(PopoverCardEl, { attrs: {
    "button-options": this.attr("button-options"),
    title: this.attr("title"),
    subtitle: this.attr("subtitle"),
    "is-segmented": this.attr("is-segmented")
  }, on: {
    action: this.helpers.handlePopoverAction,
    close: this.helpers.handlePopoverClose
  } }, /* @__PURE__ */ jsx("slot", null), /* @__PURE__ */ jsx("slot", { attrs: {
    name: "footer",
    slot: "footer"
  } }))));
}
